import Component from "./component";
import { generateClassName } from "./utils";
import { registerComponent } from "./jquery";
import { mmPostShare, mmPostShareOptions } from "@/types";
import Sortable from "sortablejs";

interface ReloadData {
  accountID?: string;
  companyID?: string;
  pageType?: string;
  canComment?: string;
  skip?: number;
  take?: number;
  isFriendEnum?: string;
}
interface ReShareData {
  companyPhoto?: string;
  elapsedTime?: string;
  photo?: string;
  fullName?: string;
  companyName?: string;
  postContentList?: string;
  rePostID?: string;
  rePostText?: string;
}

class PostShare extends Component<mmPostShareOptions> implements mmPostShare {
  private _dxPopup!: DevExpress.ui.dxPopup;
  private _contentElement!: JQuery;
  private _sortable?: any;
  constructor(element: HTMLElement, options?: mmPostShareOptions) {
    super(element, options);

    this._dxPopup = $(this._element)
      .dxPopup({
        width: this._options.width,
        height: this._options.height,
        title: this._options.title,
        visible: this._options.visible,
        hideOnOutsideClick: this._options.hideOnOutsideClick,
        dragEnabled: this._options.dragEnabled,
        shading: this._options.shading,
        shadingColor: this._options.shadingColor,
        resizeEnabled: this._options.resizeEnabled,

        contentTemplate: (container: JQuery) => {
          this._createContent(container);
        },

        wrapperAttr: {
          class: generateClassName("postShare", this._options.color!, this._options.size!, this._options.className),
          ...(this._options.attributes ?? {}),
        },

        onShown: () => {
          this._initializeComponents();
          this._updateSelectedMedia().then(() => {
            if (this._options.isEdit && this._selectedFiles.length > 0) {
              const shareButton = $("#shareButton").mmButton("instance");
              shareButton.disabled = true;
            }
          });

          const textAreaInstance = $("#postshare-textarea").dxTextArea("instance");

          if (this._options.isRepost) {
            console.log("repost");
            textAreaInstance.option("minHeight", "80px");
          }
        },

        onHiding: () => {
          this._contentElement.empty();
          this._selectedFiles = [];
        },
      })
      .dxPopup("instance");
  }

  private _createContent(container: JQuery): void {
    const loadingHtml = `
    <div class="postshare-loading">
      <div class="mm-loading mm-loading-xl mm-loading-primary"></div>
    </div>
  `;

    container.append(loadingHtml);
    this._contentElement = container;
  }
  private _updateCharAndButtonState(value: string) {
    const shareButton = $("#shareButton").mmButton("instance");
    const circle = this._contentElement.find(".char-counter-progress");
    const charText = this._contentElement.find(".char-counter-text");
    const maxChars = 1000;
    const r = 11.5;
    const circumference = 2 * Math.PI * r;

    const count = value.length;
    shareButton.disabled = !(count > 0 || this._selectedFiles.length > 0);

    const progress = Math.min(count / maxChars, 1);
    const offset = circumference * (1 - progress);
    circle.attr("stroke-dashoffset", offset);

    let color = "#2196F3";
    if (count >= 700 && count < 1000) color = "#FF9800";
    if (count === 1000) color = "#F44336";
    circle.attr("stroke", color);

    charText.text(`${count} / ${maxChars}`);
  }

  private _initializeSortable(): void {
    const containerEl = this._contentElement.find(".postshare-selected-media")[0];
    if (!containerEl) return;

    if (this._sortable) {
      try {
        this._sortable.destroy();
      } catch (err) {}
      this._sortable = undefined;
    }

    this._sortable = Sortable.create(containerEl, {
      animation: 150,
      onEnd: (evt) => {
        const oldIndex = evt.oldIndex!;
        const newIndex = evt.newIndex!;
        if (oldIndex === newIndex) return;

        const movedItem = this._selectedFiles.splice(oldIndex, 1)[0];
        this._selectedFiles.splice(newIndex, 0, movedItem);

        this._updateMediaIndexes();

        const shareButton = $("#shareButton").mmButton("instance");
        const textareaValue = $("#postshare-textarea").dxTextArea("instance").option("value") as string | undefined;
        shareButton.disabled = !((textareaValue?.length ?? 0) > 0 || this._selectedFiles.length > 0);
      },
    });
  }

  private _selectedFiles: (File | string)[] = Array.isArray(this._options.selectedFiles)
    ? this._options.selectedFiles
    : this._options.selectedFiles
      ? [this._options.selectedFiles]
      : [];
  private _removedFiles: string[] = [];
  private _selectedVisibility: string = this._options.selectedVisibility || "edc4187c-596c-4e01-059b-08db0e56c401";
  private _selectedComment: string = this._options.selectedComment || "edc4187c-596c-4e01-059b-08db0e56c401";

  private _initializeComponents(): void {
    function formatElapsedTime(createdTime: string | number | Date): string {
      if (!createdTime) return "";

      const createdDate = new Date(createdTime);
      if (isNaN(createdDate.getTime())) return "";

      const now = new Date();
      const diffMs = now.getTime() - createdDate.getTime();

      const diffMinutes = Math.ceil(diffMs / (1000 * 60));
      let elapsedTimeString = "";

      if (diffMinutes < 60) {
        elapsedTimeString = `${diffMinutes} minute${diffMinutes > 1 ? "s" : ""} ago`;
      } else {
        const diffHours = Math.ceil(diffMs / (1000 * 60 * 60));
        if (diffHours < 24) {
          elapsedTimeString = `${diffHours} hour${diffHours > 1 ? "s" : ""} ago`;
        } else if (diffHours === 24) {
          elapsedTimeString = "1 day ago";
        } else {
          const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
          if (diffDays > 7) {
            const datePart = createdDate.toLocaleDateString("en-GB");
            const timePart = createdDate.toTimeString().substring(0, 5);
            elapsedTimeString = `${datePart} ${timePart}`;
          } else {
            elapsedTimeString = `${diffDays} day${diffDays > 1 ? "s" : ""} ago`;
          }
        }
      }

      return elapsedTimeString;
    }

    function getConditionalDivs(reShareData: ReShareData | undefined, isRepost?: boolean, isJob?: boolean) {
      let html = "";

      if (isRepost && reShareData?.rePostText) {
        const formattedElapsed = formatElapsedTime(reShareData?.elapsedTime ?? 0);
        console.log(formattedElapsed);
        html += `
      <div class="postshare-repost">
        <div class="postshare-repost-header">
          <img class="postshare-repost-user-photo" src="${reShareData.photo}" />
          <div class="d-flex flex-column">
            <div class="postshare-repost-user-name">${reShareData.fullName ?? ""}</div>
          <div class="postshare-repost-time">${formattedElapsed}</div>
          </div>
        </div>
        <div class="postshare-repost-body">
          <div class="postshare-repost-text">${reShareData.rePostText ?? ""}</div>
        </div>
      </div>
    `;
      }

      if (isJob) {
        html += `<div class="postshare-job-info">This is a job post</div>`;
      }

      return html;
    }

    const {
      userName,
      userPhoto,
      userCompanyName,
      userToken,
      isEdit,
      baseUrl,
      isRepost,
      isJob,
      reShareData,
      isCompany,
    } = this._options;

    const contentHtml = `
    <div class="mm-postshare-content" style="display:none">
      <input type="file" id="postshare-media-input" accept=".jpg, .jpeg, .png, .gif, .bmp, .mp4" multiple hidden />
      <div class="postshare-header">
        <div class="postshare-user-img">
          <img src="${userPhoto ?? ""}" alt="${userName ?? ""}">
        </div>
        <div class="postshare-user">
          <div class="postshare-user-name">${userName ?? ""}</div>
          <div class="postshare-user-company-name">${userCompanyName ?? ""}</div>
        </div>
      </div>
      <div class="postshare-body">
        <div id="postshare-body-scroll">
          <div id="postshare-textarea"></div>
          <div class="postshare-selected-media"></div>
      ${getConditionalDivs(reShareData as ReShareData, isRepost, isJob)}
        </div>
      </div>
      <div class="postshare-footer">
        <div class="postshare-footer-top">
          <div class="postshare-footer-top-add">
            <div id="postshare-media"></div>
            <div>
            <div id="aiPopup"></div>
              <div id="postshare-ai"></div>
            </div>
          </div>
          <div>
            <div id="settingsPopup"></div>
            <div id="postshare-settings"></div>
          </div>
        </div>
        <div class="postshare-footer-bottom">
          <div class="postshare-footer-bottom-left">
            <div class="postshare-footer-error">
              <div class="postshare-footer-error-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="2.16 1.25 19.67 21.5"><path d="M12 7.75V13M21.08 8.58v6.84c0 1.12-.6 2.16-1.57 2.73l-5.94 3.43c-.97.56-2.17.56-3.15 0l-5.94-3.43a3.15 3.15 0 0 1-1.57-2.73V8.58c0-1.12.6-2.16 1.57-2.73l5.94-3.43c.97-.56 2.17-.56 3.15 0l5.94 3.43c.97.57 1.57 1.6 1.57 2.73Z" stroke="#c62828" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 16.2v.1" stroke="#c62828" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </div>
              <span></span>
            </div>
          </div>
          <div class="postshare-footer-bottom-right">
            <div class="postshare-char-counter-wrapper">
              <div class="char-counter-text">0 / 1000</div>
              <svg class="char-counter-circle" width="26" height="26">
                <circle class="char-counter-bg" cx="13" cy="13" r="11.5" stroke="#e0e0e0" stroke-width="3" fill="none"/>
                <circle class="char-counter-progress" cx="13" cy="13" r="11.5" stroke="#2196F3" stroke-width="3" fill="none" stroke-dasharray="72.26" stroke-dashoffset="72.26" stroke-linecap="round"/>
              </svg>
            </div>
            <div id="shareButton"></div>
          </div>
        </div>
      </div>
    </div>
  `;

    this._contentElement.append(contentHtml);

    const contentEl = this._contentElement.find(".mm-postshare-content");

    const scrollView = contentEl
      .find("#postshare-body-scroll")
      .dxScrollView({
        height: "100%",
        width: "100%",
        useNative: true,
      })
      .dxScrollView("instance");
    const postShareInstance = this;
    const r = 11.5;
    const circumference = 2 * Math.PI * r;
    const maxChars = 1000;
    const initialText = this._options.postText ?? "";

    const $textarea = contentEl.find("#postshare-textarea").mmTextArea({
      placeholder: "What's on your mind?",
      width: "100%",
      maxLength: maxChars,
      color: "default",
      minHeight: "322px",
      value: initialText,
      size: "md",
      autoResizeEnabled: true,
      onInput: (e) => {
        const value = e.event.target.value || "";
        this._updateCharAndButtonState(value);
      },
    });

    const textareaElement = $textarea.find("textarea");
    textareaElement.on("wheel", function (e: JQuery.TriggeredEvent) {
      const wheelEvent = e.originalEvent as WheelEvent;
      scrollView.scrollBy(wheelEvent.deltaY);
      e.preventDefault();
    });
    contentEl.find("#shareButton").mmButton({
      text: "Share",
      size: "md",
      color: "primary",
      disabled: true,
      onClick: () => {
        var shareButton = $("#shareButton").mmButton("instance");
        shareButton.isLoading = true;

        const postText = contentEl.find("#postshare-textarea").dxTextArea("instance")?.option("value") ?? "";
        const accountId = this._options.accountId ?? "";

        const formData = this._createFormData(postText, accountId);
        let ajaxUrl;

        if (isEdit) {
          ajaxUrl = baseUrl + "social/v1/Posts/Update";
        } else if (isCompany) {
          ajaxUrl = baseUrl + "social/v1/Companies/Insert-Post";
        } else {
          ajaxUrl = baseUrl + "social/v1/Posts/Insert";
        }

        $.ajax({
          url: ajaxUrl,
          type: isEdit ? "PUT" : "POST",
          data: formData,
          processData: false,
          contentType: false,
          beforeSend: (xhr) => {
            xhr.setRequestHeader("Authorization", "Bearer " + userToken);
          },
          success: (result) => {
            this.hide();
            shareButton.isLoading = false;

            const reloadData: ReloadData = {
              accountID: accountId ?? "",
              pageType: "feed",
              canComment: "",
              skip: 0,
              take: 10,
              isFriendEnum: "",
              companyID:this._options.companyId,
            };

            const data = JSON.stringify(reloadData);

            if (this._options.reloadComponent && this._options.reloadTarget && this._options.reloadViewName) {
              this._options.reloadComponent(this._options.reloadViewName, data, this._options.reloadTarget);
            }
          },
          error: (jqXHR) => {
            shareButton.isLoading = false;
            console.error("Error occurred");
          },
        });
      },
    });
    if (initialText && initialText.length > 0) {
      this._updateCharAndButtonState(initialText);
    }
    contentEl.find("#postshare-media").mmButton({
      text: "Media",
      size: "sm",
      icon: "gallery-add",
      color: "default",
      style: "outlined",
      onClick: function () {
        $("#postshare-media-input").trigger("click");
      },
    });

    const wrapper = $(".mm-postShare .dx-popup-normal");
    const $settingsButton = contentEl.find("#postshare-settings");
    const $aiButton = contentEl.find("#postshare-ai");
    const visibilityOptions = [
      { id: 1, typeId: "edc4187c-596c-4e01-059b-08db0e56c401", name: "Everyone", icon: "world", disabled: false },
      {
        id: 2,
        typeId: "2634aaf9-45a4-4565-059c-08db0e56c401",
        name: "Friends",
        icon: "users",
        disabled: false,
      },
      {
        id: 3,
        typeId: "111fa5d9-0115-4a8b-059d-08db0e56c401",
        name: "Only me",
        icon: "lock",
        disabled: false,
      },
    ];

    const commentOptions = [
      {
        id: 1,
        typeId: "edc4187c-596c-4e01-059b-08db0e56c401",
        name: "Everyone",
        icon: "world",
        disabled: false,
      },
      {
        id: 2,
        typeId: "2634aaf9-45a4-4565-059c-08db0e56c401",
        name: "Friends",
        icon: "users",
        disabled: false,
      },
      {
        id: 3,
        typeId: "111fa5d9-0115-4a8b-059d-08db0e56c401",
        name: "Only me",
        icon: "lock",
        disabled: false,
      },
    ];

    contentEl.find("#settingsPopup").dxPopup({
      hideOnOutsideClick: true,
      width: 275,
      height: 175,
      container: wrapper,
      dragEnabled: false,
      title: "Post Settings",
      resizeEnabled: false,
      shading: true,
      wrapperAttr: { class: "settingsPopup" },
      shadingColor: "rgba(0,0,0,0)",
      position: { my: "right bottom", at: "right top", of: $settingsButton, offset: "0 -5" },
      contentTemplate: (container) => {
        const body = $("<div>").addClass("settingsPopup-body").appendTo(container);

        $("<span>").addClass("postSettingsLabel").text("Who can see this post?").appendTo(body);
        $("<div>").attr("id", "postSettingsSeePost").appendTo(body);

        ($("#postSettingsSeePost") as any).mmSelectBox({
          color: "default",
          size: "sm",
          width: "100%",
          style: "filled",
          dataSource: visibilityOptions,
          displayExpr: "name",
          valueExpr: "typeId",
          value: this._selectedVisibility,
          onValueChanged: (e: { value: string }) => {
            this._selectedVisibility = e.value;
          },
        });

        $("<span>").addClass("postSettingsLabel").text("Who can comment?").appendTo(body);
        $("<div>").attr("id", "postSettingsCanComment").appendTo(body);

        ($("#postSettingsCanComment") as any).mmSelectBox({
          color: "default",
          size: "sm",
          width: "100%",
          style: "filled",
          dataSource: commentOptions,
          displayExpr: "name",
          valueExpr: "typeId",
          value: this._selectedComment,
          onValueChanged: (e: { value: string }) => {
            this._selectedComment = e.value;
          },
        });
      },
    });

    const settingsPopup = contentEl.find("#settingsPopup").dxPopup("instance");

    contentEl.find("#postshare-settings").mmButton({
      text: "Settings",
      size: "sm",
      icon: "setting",
      color: "default",
      style: "outlined",
      onClick: function () {
        settingsPopup.show();
      },
    });

    contentEl.find("#aiPopup").dxPopup({
      hideOnOutsideClick: true,
      width: 450,
      height: 180,
      container: wrapper,
      dragEnabled: false,
      showTitle: false,
      resizeEnabled: false,
      shading: true,
      wrapperAttr: { class: "aiPopup" },
      shadingColor: "rgba(0,0,0,0)",
      position: { my: "left bottom", at: "left top", of: $aiButton, offset: "-25 -5" },
      contentTemplate: (container) => {
        this._createAiContent(container);
      },
      onHiding: () => {
        const aiPopupInstance = contentEl.find("#aiPopup").dxPopup("instance");
        const container = aiPopupInstance.content();
        container.empty();
        aiPopupInstance.option("height", "180px");
      },
      onShown: () => {
        const aiPopupInstance = contentEl.find("#aiPopup").dxPopup("instance");
        const container = aiPopupInstance.content();
        aiPopupInstance.option("height", "180px");
        if (container.children().length === 0) {
          this._createAiContent(container);
        }
      },
    });

    const aiPopup = contentEl.find("#aiPopup").dxPopup("instance");

    contentEl.find("#postshare-ai").mmButton({
      text: "AI",
      size: "sm",
      icon: "sparkles",
      color: "default",
      style: "outlined",
      onClick: function () {
        aiPopup.show();
      },
    });

    this._contentElement.find(".postshare-loading").remove();

    this._contentElement.off("change", "#postshare-media-input");

    this._contentElement.on("change", "#postshare-media-input", async (e) => {
      const input = e.target as HTMLInputElement;
      if (!input.files) return;

      const errorElWrapper = this._contentElement.find(".postshare-footer-error");
      const errorElSpan = errorElWrapper.find("span");
      errorElWrapper.hide();
      errorElSpan.text("");

      const allowedTypes = ["image/jpeg", "image/png", "image/gif", "image/bmp", "video/mp4"];
      const unsupportedExtensions: string[] = [];
      const supportedFiles: File[] = [];

      for (let i = 0; i < input.files.length; i++) {
        const file = input.files[i];
        if (allowedTypes.includes(file.type)) {
          supportedFiles.push(file);
        } else {
          const ext = file.name.split(".").pop()?.toLowerCase() ?? "";
          if (!unsupportedExtensions.includes(ext)) unsupportedExtensions.push(ext);
        }
      }

      const newFiles = supportedFiles.filter(
        (file) =>
          !this._selectedFiles.some((f) => {
            return typeof f !== "string" && f.name === file.name && f.size === file.size;
          }),
      );

      if (this._selectedFiles.length + newFiles.length > 5) {
        errorElWrapper.css("display", "flex");
        errorElSpan.html(`You can only select up to 5 files.`);
        input.value = "";
        return;
      }

      this._selectedFiles.push(...newFiles);

      if (unsupportedExtensions.length > 0) {
        errorElWrapper.css("display", "flex");
        errorElSpan.html(
          `Unsupported file type(s): ${unsupportedExtensions.join(", ")}.<br>Allowed types: .jpg, .jpeg, .png, .gif, .bmp, .mp4`,
        );
        input.value = "";
        return;
      }

      supportedFiles.forEach((file) => {
        if (!this._selectedFiles.some((f) => typeof f !== "string" && f.name === file.name && f.size === file.size)) {
          this._selectedFiles.push(file);
        }
      });

      await this._updateSelectedMedia();
      this._initializeSortable();
      input.value = "";
    });

    contentEl.show();
  }

  private _createAiContent(container: JQuery) {
    const contentEl = this._contentElement;
    const userToken = this._options.userToken;

    const body = $("<div>").addClass("aiPopup-wrapper").appendTo(container);

    const flexTopRow = $("<div>").addClass("d-flex align-items-center justify-content-between gap-2").appendTo(body);

    $("<div>")
      .addClass("aiPopup-title")
      .html(
        `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#175df7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="1 1 22 22" width="20" height="20">
        <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"/>
        <path d="M20 2v4"/>
        <path d="M22 4h-4"/>
        <circle cx="4" cy="20" r="2"/>
      </svg>
      <span>AI Assistant</span>
    `,
      )
      .appendTo(flexTopRow);

    const flexTopRowRight = $("<div>").addClass("aiPopup-title-buttons").appendTo(flexTopRow);

    const generateBtn = $("<div>")
      .mmButton({ text: "Generate", color: "primary", icon: "lightning", size: "sm", style: "contained" })
      .appendTo(flexTopRowRight);

    const rewriteBtn = $("<div>")
      .mmButton({ text: "Rewrite", color: "default", icon: "refresh2", size: "sm", style: "text" })
      .appendTo(flexTopRowRight);

    const generateTab = $("<div>").addClass("aiPopup-generate").appendTo(body);
    const rewriteTab = $("<div>").addClass("aiPopup-rewrite").appendTo(body).hide();

    $("<span>")
      .addClass("aiPopup-title-sub")
      .text("Describe what you want to post about and AI will create new content for you.")
      .appendTo(generateTab);

    $("<div>")
      .mmTextBox({
        color: "default",
        placeholder: "Describe what you want to post about...",
        size: "sm",
        mode: "text",
        style: "filled",
        width: "100%",
        inputAttr: { id: "generateInput" },
      })
      .appendTo(generateTab);

    const generateBottom = $("<div>").addClass("d-flex gap-1 mt-4").appendTo(generateTab);

    $("<div>")
      .mmButton({
        text: "Generate",
        color: "primary",
        icon: "lightning",
        size: "sm",
        style: "contained",
        attributes: { id: "generateButton" },
        onClick: () => {
          const topicText = $("#generateInput").val() as string;

          if (topicText.length > 80) {
            alert("The prompt cannot be longer than 80 characters.");
            return;
          }
          const baseUrl = this._options.baseUrl;

          const generateButtonInstance = $("#generateButton").mmButton("instance");
          generateButtonInstance.isLoading = true;
          const aiPopupInstance = $("#aiPopup").dxPopup("instance");

          $.ajax({
            url: baseUrl + "social/v1/Posts/CreatePostText",
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify({ promptText: topicText }),
            beforeSend: function (xhr) {
              xhr.setRequestHeader("Authorization", "Bearer " + userToken);
            },
            success: (response) => {
              if (response.success && response.data && response.data.postText) {
                this._updateCharAndButtonState(response.data.postText);
                contentEl.find("#postshare-textarea").mmTextArea("instance").value = response.data.postText;
                generateButtonInstance.isLoading = false;
                aiPopupInstance.hide();
              }
            },
            error: function (xhr, status, error) {
              console.error("API request failed:", status, error);
              generateButtonInstance.isLoading = false;
            },
          });
        },
      })
      .appendTo(generateBottom);

    $("<div>")
      .mmButton({
        text: "Cancel",
        color: "default",
        size: "sm",
        style: "contained",
        onClick: () => {
          const aiPopup = $("#aiPopup").dxPopup("instance");
          aiPopup.hide();
        },
      })
      .appendTo(generateBottom);

    $("<span>")
      .addClass("aiPopup-title-sub")
      .text("Tell AI how you want to improve or rewrite your existing content.")
      .appendTo(rewriteTab);

    const textareaValue = contentEl.find("#postshare-textarea").mmTextArea("instance").value;

    const isActive = typeof textareaValue === "string" && textareaValue.length > 0;

    if (isActive) {
      $("<span>").addClass("aiPopup-rewrite-current-title").text("Current content:").appendTo(rewriteTab);

      $("<div>")
        .addClass("aiPopup-rewrite-current")
        .html(textareaValue)
        .appendTo(rewriteTab)
        .dxScrollView({ direction: "vertical" });
    }

    $("<div>")
      .mmTextBox({
        color: "default",
        placeholder: isActive
          ? "How should AI rewrite this? (e.g., more professional, casual, shorter...)"
          : "Please write some content first to rewrite it.",
        size: "sm",
        mode: "text",
        style: "filled",
        width: "100%",
        inputAttr: { id: "rewriteInput" },
        disabled: !isActive,
      })
      .appendTo(rewriteTab);

    const rewriteBottom = $("<div>").addClass("d-flex gap-1 mt-4").appendTo(rewriteTab);

    $("<div>")
      .mmButton({
        text: "Rewrite",
        color: "primary",
        size: "sm",
        icon: "refresh2",
        style: "contained",
        disabled: !isActive,
        attributes: { id: "rewriteButton" },
        onClick: () => {
          const topicTextCurrent = contentEl.find("#postshare-textarea").mmTextArea("instance").value;
          const topicTextRewrite = $("#rewriteInput").val() as string;
          const rewriteButtonInstance = $("#rewriteButton").mmButton("instance");
          rewriteButtonInstance.isLoading = true;
          const aiPopupInstance = $("#aiPopup").dxPopup("instance");
          const baseUrl = this._options.baseUrl;
          $.ajax({
            url: baseUrl + "social/v1/Posts/CreatePostText",
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify({ currentText: topicTextCurrent, forRewrite: true, promptText: topicTextRewrite }),
            beforeSend: function (xhr) {
              xhr.setRequestHeader("Authorization", "Bearer " + userToken);
            },
            success: (response) => {
              if (response.success && response.data && response.data.postText) {
                this._updateCharAndButtonState(response.data.postText);
                contentEl.find("#postshare-textarea").mmTextArea("instance").value = response.data.postText;
                rewriteButtonInstance.isLoading = false;
                aiPopupInstance.hide();
              }
            },
            error: function (xhr, status, error) {
              console.error("API request failed:", status, error);
              rewriteButtonInstance.isLoading = false;
            },
          });
        },
      })
      .appendTo(rewriteBottom);

    $("<div>")
      .mmButton({
        text: "Cancel",
        color: "default",
        size: "sm",
        style: "contained",
        onClick: () => {
          const aiPopup = $("#aiPopup").dxPopup("instance");
          aiPopup.hide();
        },
      })
      .appendTo(rewriteBottom);

    generateBtn.on("click", () => {
      generateTab.show();
      rewriteTab.hide();

      const genInst = generateBtn.mmButton("instance");
      const rewInst = rewriteBtn.mmButton("instance");

      genInst.color = "primary";
      genInst.style = "contained";
      rewInst.color = "default";
      rewInst.style = "text";

      const aiPopup = contentEl.find("#aiPopup").dxPopup("instance");
      aiPopup.option("height", "180px");
    });

    rewriteBtn.on("click", () => {
      generateTab.hide();
      rewriteTab.show();

      const genInst = generateBtn.mmButton("instance");
      const rewInst = rewriteBtn.mmButton("instance");

      rewInst.color = "primary";
      rewInst.style = "contained";
      genInst.color = "default";
      genInst.style = "text";

      const aiPopup = contentEl.find("#aiPopup").dxPopup("instance");
      if (isActive) {
        aiPopup.option("height", "275px");
      } else {
        aiPopup.option("height", "180px");
      }
    });
  }

  private _createFormData(postText: string, accountId: string): FormData {
    const formData = new FormData();
    formData.append("accountID", accountId);
    formData.append("postText", postText);
    formData.append("visibilityPreference", this._selectedVisibility);
    formData.append("canComment", this._selectedComment);

    if (this._options.isEdit && this._removedFiles.length > 0) {
      formData.append("removedFiles", JSON.stringify(this._removedFiles));
    }

    if (this._options.postID && this._options.postID !== "") {
      formData.append("postID", this._options.postID);
    }
    if (this._options.companyId && this._options.companyId !== "") {
      formData.append("companyID", this._options.companyId);
    }

    if (this._options.isRepost && this._options.reShareData?.rePostID) {
      formData.append("rePostID", this._options.reShareData.rePostID);
    }

    if (this._options.isRepost && this._options.reShareData?.rePostText) {
      formData.append("rePostText", this._options.reShareData.rePostText);
    }

    console.log(this._options.reShareData);

    this._selectedFiles.forEach((fileOrUrl) => {
      if (fileOrUrl instanceof File) {
        formData.append("files", fileOrUrl);
      } else if (typeof fileOrUrl === "string") {
        formData.append("files", fileOrUrl);
      }
    });

    return formData;
  }

  private async _updateSelectedMedia(): Promise<void> {
    const container = this._contentElement.find(".postshare-selected-media");
    container.empty();
    const textAreaInstance = $("#postshare-textarea").dxTextArea("instance");

    if (this._selectedFiles.length > 0) {
      textAreaInstance.option("minHeight", "201px");
    } else {
      textAreaInstance.option("minHeight", "322px");
    }

    const sources = await Promise.all(
      this._selectedFiles.map(async (file) => {
        if (typeof file === "string") {
          return file;
        } else {
          return await this._readFile(file);
        }
      }),
    );

    sources.forEach((src, index) => {
      const fileOrUrl = this._selectedFiles[index];
      const isVideo =
        typeof fileOrUrl === "string"
          ? fileOrUrl.match(/\.(mp4|webm|ogg)$/i) !== null
          : fileOrUrl.type.startsWith("video/");

      const fileName = typeof fileOrUrl === "string" ? `url-${index}` : fileOrUrl.name;

      const mediaEl = container.find(`[data-file-name="${fileName}"]`);

      if (!mediaEl.length) {
        const newEl = $(`
                <div class="postshare-selected-media-each" data-file-name="${fileName}">
                    ${isVideo ? `<video src="${src}" muted autoplay loop></video>` : `<img src="${src}" />`}
                    <div class="postshare-remove-media-wrapper">
                        <span class="postshare-remove-media" data-index="${index}">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" 
                                 viewBox="0 0 24 24" fill="none">
                                <path d="M21 5.98c-3.33-.33-6.68-.5-10.02-.5-1.98 0-3.96.1-5.94.3L3 5.98M8.5 4.97l.22-1.31C8.88 2.71 
                                         9 2 10.69 2h2.62c1.69 0 1.82.75 1.97 1.67l.22 1.3M18.85 9.14l-.65 
                                         10.07C18.09 20.78 18 22 15.21 22H8.79C6 22 5.91 20.78 5.8 
                                         19.21L5.15 9.14M10.33 16.5h3.33M9.5 12.5h5" 
                                         stroke="#292929" stroke-width="1.5" stroke-linecap="round" 
                                         stroke-linejoin="round"/>
                            </svg>
                        </span>
                    </div>
                </div>
            `);
        container.append(newEl);
      }
    });
    container.off("click", ".postshare-remove-media");
    container.on("click", ".postshare-remove-media", (e) => {
      const target = $(e.currentTarget);
      const idx = Number(target.data("index"));
      if (!isNaN(idx)) {
        const removed = this._selectedFiles[idx];

        if (this._options.isEdit && typeof removed === "string" && removed.startsWith("http")) {
          if (!this._removedFiles.includes(removed)) {
            this._removedFiles.push(removed);
          }
        }

        this._selectedFiles.splice(idx, 1);
        this._updateSelectedMedia();
      }
    });

    const scrollView = this._contentElement.find("#postshare-body-scroll").dxScrollView("instance");
    scrollView.scrollTo(scrollView.scrollHeight());

    const shareButton = $("#shareButton").mmButton("instance");
    const textareaValue = $("#postshare-textarea").dxTextArea("instance").option("value") as string;

    shareButton.disabled = !((textareaValue?.length ?? 0) > 0 || this._selectedFiles.length > 0);

    this._updateMediaIndexes();
    this._initializeSortable();
  }

  private _readFile(file: File): Promise<string> {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve(e.target?.result as string);
      reader.readAsDataURL(file);
    });
  }

  private _updateMediaIndexes(): void {
    this._contentElement.find(".postshare-selected-media .postshare-remove-media").each((i, el) => {
      el as unknown as HTMLElement;
      const $el = $(el as HTMLElement);
      $el.data("index", i);
    });
  }

  public show(): void {
    this._dxPopup.show();
  }

  public hide(): void {
    this._dxPopup.hide();
  }

  public getDefaults(): Partial<mmPostShareOptions> {
    return {
      visible: false,
      hideOnOutsideClick: false,
      width: 600,
      height: 560,
      dragEnabled: false,
      title: "Post Something",
      resizeEnabled: false,
      shading: true,
      shadingColor: "rgba(0,0,0,0.6)",
      size: "md",
      color: "default",
    };
  }
}

registerComponent("mmPostShare", PostShare);

export default PostShare;
